import React from 'react';
import classnames from 'classnames';
import { Icon } from '../icon';
import styles from './toggle-check.module.scss';

export type ToggleCheckProps = { label: string; size?: '200' | '300' } & Pick<
  React.InputHTMLAttributes<HTMLInputElement>,
  'defaultChecked' | 'checked' | 'name' | 'value' | 'className' | 'disabled' | 'required' | 'onChange' | 'id'
>;

export const ToggleCheck: React.FC<ToggleCheckProps> = ({
  label,
  disabled,
  name,
  value,
  defaultChecked,
  checked,
  onChange,
  required,
  size = '300'
}) => {
  const icon = size === '300' ? 'successful-checkmark--medium' : 'successful-checkmark--small';
  return (
    <label className={classnames(styles.toggleCheck, styles[`s${size}`])} data-testid="toggle-check-component">
      <input
        type="checkbox"
        disabled={disabled}
        className={styles.input}
        defaultChecked={defaultChecked}
        checked={checked}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
      />
      <div className={styles.circle}>
        <Icon name={icon} className={styles.icon} aria-hidden />
      </div>
      <div className={styles.hiddenLabel}>{label}</div>
    </label>
  );
};
